import { FormCrud } from "components/Form/hooks";
import { isSubmitting } from "redux-form";
import { loginHooks } from "..";
import { useSelector } from "react-redux";

const useSubmitBtn = () => {
    const { formname } = loginHooks.constants
    const { actionSubmit } = FormCrud()
    const isSubmittingForm = useSelector((state) => isSubmitting(formname)(state))

    const submitBtn = {
        id: 0,
        label: "כניסה",
        variant: "regular2",
        color: "thirdly",
        action: () => actionSubmit(formname),
        loading: isSubmittingForm
    }

    return submitBtn
}

export default useSubmitBtn;